/* External dependencies */
import { ICognitoUserPoolData } from 'amazon-cognito-identity-js';

/* Local dependencies */
import {
  AuthActionTypes,
  AuthViewMode,
  ConfirmRegistrationError,
  ConfirmRegistrationRequest,
  ConfirmRegistrationSuccess,
  InitClient,
  InitClientFailed,
  InitClientSucceeded,
  LogoutError,
  LogoutRequest,
  LogoutSuccess,
  SendAuthError,
  SendVerificationCodeRequest,
  SetAuthViewMode,
  SetConfirmationCode,
  SetUserSession,
} from './types';

export function initClient(): InitClient {
  return {
    type: AuthActionTypes.INIT_CLIENT,
  };
}

export function initClientFailed(): InitClientFailed {
  return {
    type: AuthActionTypes.INIT_CLIENT_FAILED,
  };
}

export function initClientSucceeded(session: any): InitClientSucceeded {
  return {
    type: AuthActionTypes.INIT_CLIENT_SUCCEEDED,
    session,
  };
}

export function initAnonymousClient(client) {
  return {
    type: AuthActionTypes.INIT_ANONYMOUS_CLIENT,
    client,
  };
}

export function logout(): LogoutRequest {
  return {
    type: AuthActionTypes.LOGOUT_REQUEST,
  };
}

export function logoutFailed(error: Error): LogoutError {
  return {
    type: AuthActionTypes.LOGOUT_ERROR,
    error,
  };
}

export function logoutSucceeded(): LogoutSuccess {
  return {
    type: AuthActionTypes.LOGOUT_SUCCESS,
  };
}

export function setAuthViewMode(mode: AuthViewMode): SetAuthViewMode {
  return {
    type: AuthActionTypes.SET_AUTH_VIEW_MODE,
    mode,
  };
}

export function sendVerificationCode(
  username: string,
  userPool: ICognitoUserPoolData,
  currentUserSession: any,
): SendVerificationCodeRequest {
  return {
    type: AuthActionTypes.SEND_VERIFICATION_CODE_REQUEST,
    username,
    userPool,
    currentUserSession,
  };
}

export function setUserSession(session: any): SetUserSession {
  return {
    type: AuthActionTypes.SET_USER_SESSION,
    session,
  };
}

export function confirmRegistration(
  username: string,
  confirmationCode: string,
  userPool: ICognitoUserPoolData,
): ConfirmRegistrationRequest {
  return {
    type: AuthActionTypes.CONFIRM_REGISTRATION_REQUEST,
    username,
    confirmationCode,
    userPool,
  };
}

export function confirmRegistrationSuccess(): ConfirmRegistrationSuccess {
  return {
    type: AuthActionTypes.CONFIRM_REGISTRATION_SUCCESS,
  };
}

export function confirmRegistrationFailed(error: any): ConfirmRegistrationError {
  return {
    type: AuthActionTypes.CONFIRM_REGISTRATION_ERROR,
    error,
  };
}

export function setConfirmationCode(code: string): SetConfirmationCode {
  return {
    type: AuthActionTypes.SET_CONFIRMATION_CODE,
    code,
  };
}

export function resetAuthState() {
  return {
    type: AuthActionTypes.RESET_AUTH_STATE,
  };
}

export function sendAuthError(error: Record<string, Error | undefined> | Error): SendAuthError {
  return {
    type: AuthActionTypes.SEND_AUTH_ERROR,
    error,
  };
}
